"use strict";
/**
 * Old documentation:
 * FSM:
 * Initial State: DRAFT
 * End States: REJECTED | RELEASED
 * Transitions:
 *  - DRAFT -> NEW_SUBMISSION
 *  - NEW_SUBMISSION -> REQUIRES_APPROVAL | NEW_BUSINESS_REVIEW
 *  - REQUIRES_APPROVAL -> REQUIRES CHANGE | REJECTED | PREPARING RELEASE | NEW_BUSINESS_REVIEW
 *  - REQUIRES_CHANGE -> REQUIRES_APPROVAL
 *  - PREPARING_RELEASE -> RELEASED
 *  - NEW_BUSINESS_REVIEW -> UNDER_BUSINESS_REVIEW
 *  - UNDER_BUSINESS_REVIEW -> NEW_BUSINESS_REVIEW | NEW_SUBMISSION | REJECTED
 *  - RELEASED -> SYNC_REQUIRED
 *  - SYNC_REQUIRED -> RELEASED
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionStatuses = exports.BasicLaunchStatuses = void 0;
exports.BasicLaunchStatuses = [
    // it's the REQUIRES_APPROVAL for basic flow submissions: used when devs submit a game build while the submission has not started Basic Launch yet
    'BASIC_LAUNCH_REQUIRES_APPROVAL',
    // the submission has been approved to move forward and implement the full requirements
    'BASIC_LAUNCH_APPROVED',
    // the submission ended basic launch with mixed results and feedback was sent to the developer
    'BASIC_LAUNCH_MIXED_RESULT',
    // the developer submitted a new build while the submission was in Basic Launch, and the build needs to be approved/rejected
    'BASIC_LAUNCH_SYNC_REQUIRED',
    // the developer submitted a new build after basic launch ended with mixed results
    'BASIC_LAUNCH_MIXED_RESULT_SYNC_REQUIRED',
    // admins have requested changes to fulfil the full requirements
    'BASIC_LAUNCH_AWAITING_DEVELOPER_CHANGE',
    // the submission is in Basic Launch
    'BASIC_LAUNCH',
];
exports.SubmissionStatuses = [
    ...exports.BasicLaunchStatuses,
    'DRAFT',
    'NEW_SUBMISSION',
    'RELEASED',
    'REQUIRES_APPROVAL',
    'PREPARING_RELEASE',
    'AWAITING_DEVELOPER_CHANGE',
    'REJECTED',
    'SYNC_REQUIRED',
    'FINALIZED',
    'NEW_BUSINESS_REVIEW',
    'UNDER_BUSINESS_REVIEW',
];
